export default {
  setNotificaciones(state, n) {
    state.notificaciones = n;
  }
}